var map = {
	"./bg_business_name.png": "89c1",
	"./bg_num_bata_bf.png": "db0a",
	"./bg_tk_bf_con_b.png": "de9a",
	"./bg_tk_bf_con_c.png": "5be1",
	"./bg_tk_bf_con_u.png": "f1aa",
	"./icon_bf_close.png": "07b1",
	"./icon_wxz.png": "0323",
	"./icon_wxz_c.png": "75cc",
	"./三门峡市.png": "1e13",
	"./临颍县.png": "cb84",
	"./习城乡.png": "e437",
	"./五星乡.png": "869b",
	"./信阳市.png": "90e5",
	"./八公桥镇.png": "405f",
	"./南阳市.png": "4e44",
	"./召陵区.png": "ec6d",
	"./周口市.png": "851c",
	"./商丘市.png": "0f75",
	"./城关镇.png": "7529",
	"./子岸镇.png": "ca97",
	"./安阳市.png": "e8877",
	"./平顶山市.png": "dc20d",
	"./庆祖镇.png": "9d48",
	"./开封市.png": "2499",
	"./徐镇镇.png": "a03c",
	"./户部寨镇.png": "18dd",
	"./文留镇.png": "8ec2",
	"./新习镇.png": "144b",
	"./新乡市.png": "e6d4",
	"./柳屯镇.png": "a0d9",
	"./梁庄镇.png": "3adf",
	"./梨园乡.png": "eceb",
	"./洛阳市.png": "d891",
	"./济源市.png": "5b71",
	"./海通乡.png": "402e",
	"./清河头乡.png": "bb0e",
	"./渠村乡.png": "c9a4",
	"./源汇区.png": "aaa5",
	"./漯河市.png": "08d6",
	"./濮阳市.png": "638a",
	"./焦作市.png": "5a5c",
	"./王称固镇.png": "a819",
	"./王称堌镇.png": "ac16",
	"./白堽乡.png": "66ea",
	"./白罡乡.png": "73a3",
	"./胡状镇.png": "7de2",
	"./舞阳县.png": "cf1b",
	"./许昌市.png": "7e2c",
	"./郎中乡.png": "bf8c",
	"./郑州市.png": "fe61",
	"./郾城区.png": "7722",
	"./驻马店市.png": "8d62",
	"./鲁河镇.png": "df45",
	"./鹤壁市.png": "7945"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9565";